const AuctionGuide = () => {
    return (
        <>
            <div className="auction-guide">
                <div className="section-banner-white-bg">HƯỚNG DẪN ĐẤU GIÁ</div>
                <div className="responsive-padding-1440">
                    <ol className="stepper">
                        <li className="stepper-item step-1">
                            <h3 className="stepper-title">Đăng ký tham gia trực tuyến</h3>
                            <p className="stepper-desc">Bạn có thể đăng ký trực tuyến tại website hoặc liên hệ với chúng tôi qua số HOTLINE: 0905.156.237</p>
                        </li>
                        <li className="stepper-item step-2">
                            <h3 className="stepper-title">Nộp tiền đặt trước</h3>
                            <p className="stepper-desc">Bạn có thể đăng ký trực tuyến tại website hoặc liên hệ với chúng tôi qua số HOTLINE: 0905.156.237</p>
                        </li>
                        <li className="stepper-item step-3">
                            <h3 className="stepper-title">Tham gia đấu giá</h3>
                            <p className="stepper-desc">Bạn có thể đăng ký trực tuyến tại website hoặc liên hệ với chúng tôi qua số HOTLINE: 0905.156.237</p>
                        </li>
                        <li className="stepper-item step-4">
                            <h3 className="stepper-title">Thủ tục sau đấu giá</h3>
                            <p className="stepper-desc">Bạn có thể đăng ký trực tuyến tại website hoặc liên hệ với chúng tôi qua số HOTLINE: 0905.156.237</p>
                        </li>
                    </ol>
                </div>
            </div>
            {/* <div className="guide-footer"></div> */}
        </>

    )
}

export default AuctionGuide;